<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Crear Procesos",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            procesos:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "nombre", sortable: true },
                { key: "estado", sortable: true },
                { key: "fecha_inicio", sortable: true },
                { key: "fecha_fin", sortable: true },
                { key: "fecha_autoevaluacion", sortable: true },
                { key: "fecha_coevaluacion", sortable: true },
                { key: "fecha_evaluacionjefe", sortable: true },
                { key: "fecha_retroalimentacion", sortable: true },
                { key: "acciones", sortable: true }
            ],
            proceso:{
                nombre:'',
                estado:false,
                fecha_inicio:'',
                fecha_fin:'',
                fecha_autoevaluacion:'',
                fecha_coevaluacion:'',
                fecha_evaluacionjefe:'',
                fecha_retroalimentacion:'',
            }
        };
    },
    computed: {
    /**
     * Total no. of records
     */
        rows() {
            return this.procesos.length;
        }
    },
    mounted() {
    // Set the initial number of items
        this.totalRows = this.items.length;
    },
    created() {
        this.actualizar();
    },
    methods: {
    /**
     * Search the table data with search input
     */
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        actualizar(){
            axios.get('/api/get_procesos').then(res=>{
                this.procesos = res.data.procesos;
                this.user.rol_id==1?console.log(this.procesos):''
                this.proceso.id=''//reinicia variables despues de crear proceso
                this.proceso.nombre=''
                this.proceso.estado=false
                this.proceso.fecha_inicio=''
                this.proceso.fecha_fin=''
                this.proceso.fecha_autoevaluacion=''
                this.proceso.fecha_coevaluacion=''
                this.proceso.fecha_evaluacionjefe=''
                this.proceso.fecha_retroalimentacion=''
            });
            //console.log('carga procesos')
        },
        crear_proceso(){
            axios.post('/api/crear_proceso', this.proceso).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    //console.log('creado')
                    this.actualizar();
                    this.$bvModal.hide('modal_proceso')
                    Swal.fire({
                        title: "Se ha creado un nuevo proceso", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    
                }else{
                    console.log('error')
                    Swal.fire({
                        title: "Error al crear proceso", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "error",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    //this.$toasted.error(res.data.mensaje);
                }
            });
        },
        editar_proceso_modal(item){
            this.proceso=item
            this.$bvModal.show('modal_proceso_editar')
        },
        editar_proceso(){
            axios.post('/api/editar_proceso', this.proceso).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    this.actualizar();
                    this.$bvModal.hide('modal_proceso_editar')
                    Swal.fire({
                        title: "Se ha editado el proceso", 
                        //text: "Debe tomar conocimiento sobre los Documentos Institucionales y Reglamentos",
                        icon: "success",
                        confirmButtonColor: "#f1b44c",
                        confirmButtonText: "Aceptar"
                    });
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                }
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right" variant="primary" v-b-modal.modal_proceso>Nuevo Proceso</b-button>
                                <b-modal id="modal_proceso" title="Crear Nuevo Proceso" ok-title="Crear" cancel-title="Cancelar" @ok="crear_proceso">
                                    <b-form-group id="example text" label-cols-sm="6" label-cols-lg="6" label="Nombre del Proceso" label-for="text">
                                        <b-form-input for="text" v-model="proceso.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="6" label-cols-lg="6" label="Estado del Proceso" label-for="text">
                                        <b-form-checkbox for="text" v-model="proceso.estado"></b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha Inicio" label-for="text">
                                        <date-picker v-model="proceso.fecha_inicio" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha Término" label-for="text">
                                        <date-picker v-model="proceso.fecha_fin" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Autoevaluación" label-for="text">
                                        <date-picker v-model="proceso.fecha_autoevaluacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Coevaluación" label-for="text">
                                        <date-picker v-model="proceso.fecha_coevaluacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Evaluación Jefe" label-for="text">
                                        <date-picker v-model="proceso.fecha_evaluacionjefe" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Retroalimentación" label-for="text">
                                        <date-picker v-model="proceso.fecha_retroalimentacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                </b-modal>
                                <b-modal id="modal_proceso_editar" title="Editar Proceso" ok-title="Editar" cancel-title="Cancelar" @ok="editar_proceso">
                                    <b-form-group id="example text" label-cols-sm="6" label-cols-lg="6" label="Nombre del Proceso" label-for="text">
                                        <b-form-input for="text" v-model="proceso.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="6" label-cols-lg="6" label="Estado del Proceso" label-for="text">
                                        <b-form-checkbox for="text" v-model="proceso.estado"></b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha Inicio" label-for="text">
                                        <date-picker v-model="proceso.fecha_inicio" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha Término" label-for="text">
                                        <date-picker v-model="proceso.fecha_fin" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Autoevaluación" label-for="text">
                                        <date-picker v-model="proceso.fecha_autoevaluacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Coevaluación" label-for="text">
                                        <date-picker v-model="proceso.fecha_coevaluacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Evaluación Jefe" label-for="text">
                                        <date-picker v-model="proceso.fecha_evaluacionjefe" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="7" label-cols-lg="7" label="Fecha comienzo Retroalimentación" label-for="text">
                                        <date-picker v-model="proceso.fecha_retroalimentacion" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
                                    </b-form-group>
                                </b-modal>
                            </div>
                        </div>
                        <!-- <h4 class="card-title">Data Table</h4> -->
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;procesos
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table :items="procesos" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" >
                                <template v-slot:cell(n)="data">
                                    <p>{{ data.index+1 }}</p>
                                </template>
                                <template v-slot:cell(estado)="data">
                                    <p v-if="data.index.estado">Activo</p>
                                    <p v-else>No activo</p>
                                </template>
                                <template v-slot:cell(acciones)="data">
                                    <b-button size="sm" variant="primary" @click="editar_proceso_modal(data.item)">Editar</b-button>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>